import Vue from 'vue'
import Vuex from 'vuex'

import { getCurrentContestConfig } from '../api/contest'
import { getUserInfo, setUserInfo } from '@/utils/cache'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: Object.assign({
      avatar: '',
      open_id: '',
      nickname: '',
      token: '',
      user_type: '',
      wx_openid: '',
    }, getUserInfo()),
    contestConfig: null,
    isLoadWxSdk: false,
  },
  mutations: {
    SET_USER_INFO(state, data) {
      if (data.logout) {
        state.userInfo = {}
      } else {
        state.userInfo = Object.assign({}, state.userInfo, data)
      }

      setUserInfo(state.userInfo)
    },
    SET_CONTEST_CONFIG(state, config) {
      state.contestConfig = config
    },
    SET_WX_SDK_LOAD_STATUS(state, loadWxSdkStatus) {
      state.isLoadWxSdk = loadWxSdkStatus
    },
  },
  actions: {
    setUserInfo({ commit }, params) {
      const data = {}
      if (params.avatar !== undefined) {
        data.avatar = params.avatar
      }

      if (params.open_id !== undefined) {
        data.open_id = params.open_id
      }

      if (params.nickname !== undefined) {
        data.nickname = params.nickname
      }

      if (params.token !== undefined) {
        data.token = params.token
      }

      commit('SET_USER_INFO', data)
    },
    removeUserInfo({ commit }) {
      commit('SET_USER_INFO', {
        logout: true,
      })
    },
    updateWxSdkLoadStatus({ commit }, loadWxSdkStatus) {
      console.log('更新状态:', loadWxSdkStatus)
      commit('SET_WX_SDK_LOAD_STATUS', loadWxSdkStatus)
    },

    async fetchCurrentContestConfig({ commit, state }, force = false) {
      if (!force && state.contestConfig) return state.contestConfig
      const contestConfig = await getCurrentContestConfig()
      console.log('contestConfig', contestConfig)
      commit('SET_CONTEST_CONFIG', contestConfig)
      return contestConfig
    },
  },
  modules: {
  },
})
